import { Text } from "@mantine/core"
import { useTranslation } from "react-i18next"
import type { TSession } from "@/types"
import { rruleLabels } from "@/utils"

export function SessionRecurrence({ rrule }: Pick<TSession, "rrule">) {
  const { t } = useTranslation()

  if (!rrule) return null

  return (
    <Text size="sm" c="dimmed">
      {t(rruleLabels[rrule] ?? rrule)}
    </Text>
  )
}
